var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.gelenval)?_c('Icon',{attrs:{"icon":"material-symbols:check-circle","color":"#28c76f","width":"25","height":"25"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }